import { useEffect, useState } from 'react';

let hydrating = true;

export function useIsClient(): boolean {
  const [hydrated, setHydrated] = useState(() => !hydrating);

  useEffect(function hydrate() {
    hydrating = false;
    setHydrated(true);
  }, []);

  return hydrated;
}
